(() => {
  if(customElements.get('pp-newsletter-status'))return;
  class NewsletterStatus extends HTMLElement {
    connectedCallback(){
      const container=this.querySelector('.pp-newsletter__form');if(!container)return;
      this.started=Date.now();this.controller=new AbortController();
      this.querySelector('[data-newsletter-reload]').addEventListener('click',()=>location.reload(),{signal:this.controller.signal});
      const update=()=>{
        const host=container.querySelector('shopify-forms-embed');
        const loaded=Boolean(host?.shadowRoot?.querySelector('input,form,button'));
        this.querySelector('[data-newsletter-loading]').hidden=loaded||Date.now()-this.started<2500||Date.now()-this.started>20000;
        this.querySelector('[data-newsletter-retry]').hidden=loaded||Date.now()-this.started<20000;
        if(loaded){clearInterval(this.timer);container.style.minHeight='0';}
      };
      this.timer=setInterval(update,1000);update();
    }
    disconnectedCallback(){clearInterval(this.timer);this.controller?.abort();}
  }
  customElements.define('pp-newsletter-status',NewsletterStatus);
})();
